import getIn from './getIn'

const getField = (form, key, defaultVal = '', grid = false) => {
  if (!form) return defaultVal
  const v = getIn(form, `fields.${key}.${grid ? 'rowData' : 'value'}`)
  return v !== undefined ? v : defaultVal
}

export default getField
